var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayroll = function SvgPayroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.95 9.226 22 8.281V4h-1V2h-1V0H4v2H3v2H2v4.281l-.946.942A3.51 3.51 0 0 0 0 11.725V24h24V11.725c0-.936-.384-1.848-1.05-2.499M5 1h14v1H5zM4 3h16v1H4zm17 2v5.45l-6.525 6.525c-1.322 1.322-3.627 1.322-4.949 0L3.001 10.45V5.001h18Zm2 18H1V11.725c0-.507.159-1.002.444-1.417l7.374 7.374C9.668 18.533 10.797 19 12 19s2.332-.468 3.182-1.318l7.375-7.374c.284.415.443.911.443 1.417zM17 8a1 1 0 1 1 2 0 1 1 0 1 1-2 0m-5 7c1.93 0 3.5-1.57 3.5-3.5S13.93 8 12 8s-3.5 1.57-3.5 3.5S10.07 15 12 15m0-6c1.379 0 2.5 1.121 2.5 2.5S13.379 14 12 14s-2.5-1.121-2.5-2.5S10.621 9 12 9M5 8a1 1 0 1 1 2 0 1 1 0 1 1-2 0"
  })));
};
export default SvgPayroll;